// Heights for both icon and wordmark variants.
const HEIGHTS = { sm: 'h-6', md: 'h-8', lg: 'h-10', xl: 'h-14' };
const SIZES_PX = { sm: 24, md: 32, lg: 40, xl: 56 };

const WORDMARK_SIZES = {
  sm: 'text-xl',
  md: 'text-2xl',
  lg: 'text-4xl',
  xl: 'text-5xl',
};

/**
 *   <RivlLogo />                      → "R" gradient app-icon (default)
 *   <RivlLogo variant="wordmark" />   → "RIVL." styled wordmark (legacy)
 *
 * The icon variant is the user-chosen brand mark: a purple→magenta rounded
 * square with a white "R" and an orange/red speed accent. Used in the
 * header, bottom tabs and favicon. The wordmark variant is kept for any
 * surface that still needs the text-based logo (e.g. legacy embeds).
 */
export function RivlLogo({ className = '', size = 'md', variant = 'icon' }) {
  if (variant === 'wordmark') {
    return (
      <span
        data-testid="rivl-wordmark"
        className={`inline-flex items-baseline font-display font-black tracking-tight leading-none select-none ${WORDMARK_SIZES[size] || WORDMARK_SIZES.md} ${className}`}
        aria-label="RIVL"
      >
        <span className="text-primary">RI</span>
        <span className="text-foreground">V</span>
        <span className="text-[#1D4ED8]">L</span>
        <span className="text-primary">.</span>
      </span>
    );
  }
  const px = SIZES_PX[size] || SIZES_PX.md;
  return (
    <img
      data-testid="rivl-logo"
      src="/icon-r.svg"
      alt="RIVL"
      width={px}
      height={px}
      className={`${HEIGHTS[size] || HEIGHTS.md} w-auto select-none ${className}`}
      draggable={false}
    />
  );
}
